import { render, staticRenderFns } from "./YouTubeSetModerationStatus.vue?vue&type=template&id=08748436&scoped=true"
import script from "./YouTubeSetModerationStatus.vue?vue&type=script&lang=js"
export * from "./YouTubeSetModerationStatus.vue?vue&type=script&lang=js"
import style0 from "./YouTubeSetModerationStatus.vue?vue&type=style&index=0&id=08748436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08748436",
  null
  
)

export default component.exports